export default __webpack_public_path__ + "96f0f6915aedfd9681140f1f33272c90.bin";